const exported = {
  Like: 'LIKE_OR_DISLIKE',
  Flag: 'FLAG',
  Rating: 'STAR',
};

export default exported;

export const { Like, Flag, Rating } = exported;
